<template lang="pug">
        div.summaryContainer
            div(v-if="campLoader")
                Loader
            div
                div.card.tw-my-4
                        div.tw-flex.tw-gap-2.tw-justify-between
                            div.tw-flex.tw-gap-3
                              div
                                div.tw-ml-2.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") Date Range
                                div
                                    date-range-picker.customDateRange(v-model="dateRange"
                                    opens='right'
                                    :autoApply="true"
                                    :locale-data="{format:'dd mmm yyyy'}"
                                    @update="formatDates()"
                                    :ranges="customRanges"
                                    :show-dropdowns="true"
                                    )
                              div
                                div.tw-ml-2.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") Channel
                                div.customMultiselectCommon.tw-mb-2.tw-w-52
                                    multiselect(
                                        v-model="selectedChannel"
                                        :options="channelList"
                                        placeholder="Select Channel"
                                        track-by="label" 
                                        label="key"
                                        :searchable="false"
                                        :show-labels="false"
                                        open-direction="bottom" 
                                        :multiple="false"
                                        :allow-empty="false"
                                        @input="handleSelectedChannel"
                                    ) 
                            div
                                div.tw-mt-4
                                    div.tw-flex.tw-justify-end.tw-items-center.tw-text-primary_brand.tw-font-medium
                                        div.tw-flex.tw-justify-center.tw-items-center.tw-bg-primary_brand-10(class="first:tw-rounded-l last:tw-rounded-r" v-for="interval of intervalsList" :key="interval.key")
                                                button.tw-text-primary_brand.tw-font-medium.tw-text-center.tw-inline-flex.tw-items-center(class="2xl:tw-text-sm xl:tw-text-xs 2xl:tw-px-3 xl:tw-px-2 2xl:tw-h-10 xl:tw-h-8 tw-text-xs tw-h-7 tw-px-2" @click="setInterval(interval)" :class="{'tw-bg-primary_brand-80 text-white tw-rounded tw-font-bold': selectedInterval.key === interval.key }") {{ interval.label }}       
            div.card.tw-mb-4
              div
                div.tw-flex.tw-flex-col
                    span(class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2" style="border-bottom:1px solid #D4D4D4") Campaign Summary        
                    div.tw-flex.tw-justify-between.tw-items-center
                      div.tw-flex.tw-gap-2
                        div
                            div.tw-ml-2.tw-mb-1.tw-font-medium(class="tw-text-[#1e1e1e] tw-text-[14px]") Campaign Type
                            div.customMultiselectCommon.tw-mb-2.tw-w-52
                                multiselect(
                                    v-model="selectedCampaignTypeData"
                                    :options="campaignOptions"
                                    placeholder="Select Campaign Type"
                                    track-by="label" 
                                    label="key"
                                    :searchable="false"
                                    :show-labels="false"
                                    open-direction="bottom" 
                                    :multiple="true"
                                    :allow-empty="false"
                                    @input="handleCampaignType"
                                )
                                    template(slot="option" slot-scope="{ option }")
                                        input(type="checkbox", :value="option" v-model="selectedCampaignTypeData")
                                        span(class="option__title tw-ml-3") {{ option.key }} 
                      div
                        button.text-white.tw-py-2.tw-px-3.tw-rounded.tw-ml-3(class="tw-bg-[#FCB117] tw-font-[500] 2xl:tw-text-[14px] tw-text-[12px]" @click="handleDownloadTable") Download      
              div(v-if="sleepwellTableData.length")
                  table#campaignDataTable.tw-w-full
                      thead
                          tr
                              th(v-for="(item, index) in sleepwellTableHeader" :key="index")
                                  span {{item.value}}
                      tbody
                          tr(v-for="(item, idx) in sleepwellTableData" :key="idx" v-if="item.Date !='Total' ")  
                              td(v-for="(head, index) in sleepwellTableHeader" :key="index")
                                  span {{item[head.key]}}

                      tfoot
                          tr(v-for="(item, index) in sleepwellTableData" :key="index" v-if="String(item.Date).includes('Total')")  
                              td(v-for="(head, index) in sleepwellTableHeader" :key="index")
                                  span {{item[head.key]}}
                  
              div.tw-p-4.tw-mb-4.tw-text-sm.tw-rounded-lg(class="tw-text-red-800 tw-bg-red-50" v-else)
                  span.tw-font-medium No Data in Table!                       
    </template>

<script>
import moment from "moment";
import Loader from "../../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { watch } from "vue";
import Multiselect from "vue-multiselect";

export default {
  name: "Sleepwell",
  components: {
    Loader,
    Treeselect,
    Multiselect,
  },
  data() {
    return {
      dataLoader: false,
      campLoader: false,
      isFilter: false,
      filterBy: "",
      asinFilterBy: "",
      isAsinFilter: false,
      treeSelectData: [],
      selectedNumericCampaignValue: "",
      selectedStringCampaignValue: "",
      selectedNumericMatricsValue: "",
      selectedStringMatricsValue: "",
      selectedAsinNumericalMatricsValue: "greater than",
      asinMatricsNumericalInputValue: "",
      selectedAsinNumericalCampaignValue: "Impressions",
      selectedAsinStringMatricsValue: "contains",
      asinMatricsStringInputValue: "",
      selectedAsinStringCampaignValue: "ASIN",
      storeNumericFilterValue: [],
      storeStringFilterValue: [],
      storeAsinFilterValue: [],
      storeAsinMetricsValue: [],
      allAsinCategory: [],
      activeCampaign: true,
      matricsInputValue: "",
      StringMatricsInputValue: "",
      sleepwellTableData: [],
      sleepwellTableHeader: [],
      metricsList: [],
      asinTableData: [],
      asinTableHeader: [],
      numericFiltersFields: [],
      stringFiltersFields: [],
      asinMatric: [],
      asinFields: [],
      asinMetricFields: [],
      selectedValue: [],
      selectedTableColumn: [],
      selectedAsinTableColumn: [],
      asinMetricsList: [],
      asinCategoryValue: null,
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      intervalsList: [
        {
          key: "daily",
          label: "Day",
        },
        {
          key: "weekly",
          label: "Week",
        },
        {
          key: "monthly",
          label: "Month",
        },
      ],
      selectedInterval: {
        key: "daily",
        label: "Day",
      },
      selectedCampaignTypeData: [
        {
          key: "Sponsored Products",
          label: "sp",
        },
      ],
      selectedTableColumn: [],
      campaignOptions: [
        {
          key: "Sponsored Products",
          label: "sp",
        },
        {
          key: "Sponsored Brands",
          label: "sb",
        },
        {
          key: "Sponsored Display",
          label: "sd",
        },
      ],
      selectedCategory: {},
      isDefaultSelectedCategory: false,
      customRanges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
      selectedChannel: [
        {
          key: "All",
          label: "All",
        },
      ],
      channelList: [
        {
          key: "All",
          label: "All",
        },
        {
          key: "Amazon",
          label: "Amazon",
        },
        {
          key: "Flipkart",
          label: "Flipkart",
        },
      ],
    };
  },
  mounted() {
    this.isDefaultSelectedCategory = true;
    this.getTableData();

    // this.$watch(
    //   "allAsinCategory",
    //   (newVal) => {
    //     if (newVal && Object.keys(newVal).length) {
    //       this.treeSelectData = this.transformToTreeSelect(newVal);
    //     }
    //   },
    //   { immediate: true }
    // );
  },
  methods: {
    formatDateRange() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.dateRange.endDate = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );
    },
    formatDates() {
      this.formatDateRange();
      this.getTableData();
      // this.getAsinReportData();
    },
    handleSelectedChannel() {
      this.getTableData();
      // this.getAsinReportData();
    },
    getTableData() {
      this.campLoader = true;
      this.sleepwellTableHeader = [];
      this.sleepwellTableData = [];
      const url = "/api/v2/amazon/performance_summary";
      $("#campaignDataTable").DataTable().destroy();
      const payload = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        channel: this.selectedChannel[0].label,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.sleepwellTableHeader = res.data.data.headers;
          this.selectedTableColumn = this.sleepwellTableHeader;
          // this.metricsList = res.data.data.headers;
          this.sleepwellTableData = res.data.data.data;
          // this.numericFiltersFields = res.data.data.numarical_filters;
          // this.stringFiltersFields = res.data.data.string_filters;
          // this.selectedNumericCampaignValue =
          //   this.numericFiltersFields.fields[0];
          // this.selectedNumericMatricsValue =
          //   this.numericFiltersFields.matrics[0];
          // this.selectedStringCampaignValue = this.stringFiltersFields.fields[0];
          // this.selectedStringMatricsValue = this.stringFiltersFields.matrics[0];
          this.$nextTick(() => {
            this.processTable("#campaignDataTable");
          });
          this.campLoader = false;
        })
        .catch((err) => {
          this.campLoader = false;
          console.log(err);
        });
    },
    // getAsinReportData() {
    //   this.dataLoader = true;
    //   this.asinTableHeader = "";
    //   this.asinTableData = "";
    //   this.asinFields = "";
    //   this.allAsinCategory = "";

    //   let url = "/api/v2/amazon/targeted/asinreport";
    //   const payload = {
    //     start_date: this.dateRange.startDate,
    //     end_date: this.dateRange.endDate,
    //     interval: this.selectedInterval.key,
    //     numarical_filters: this.storeAsinFilterValue.flat(),
    //     category_filters: this.selectedCategory,
    //     asin_string_filters: this.storeAsinMetricsValue.flat(),
    //     channel: this.selectedChannel.label,
    //   };
    //   this.$http
    //     .post(url, payload)
    //     .then((res) => {
    //       this.asinTableHeader = res.data.data.headers;
    //       this.selectedAsinTableColumn = this.asinTableHeader;
    //       this.asinMetricsList = res.data.data.headers;
    //       this.asinTableData = res.data.data.data;
    //       this.asinFields = res.data.data;
    //       this.allAsinCategory = res.data.data.category;
    //       this.asinMetricFields = res.data.data.asin_string_metric;
    //       this.treeSelectData = this.transformToTreeSelect(
    //         res.data.data.category
    //       );
    //       if (
    //         this.treeSelectData &&
    //         this.treeSelectData.length > 0 &&
    //         this.isDefaultSelectedCategory
    //       ) {
    //         this.asinCategoryValue = [this.treeSelectData[0].id];
    //         this.handleTreeSelect(this.treeSelectData[0]);
    //       }
    //       this.isDefaultSelectedCategory = false;
    //       this.$nextTick(() => {
    //         this.processTable("#asinDataTable");
    //       });
    //       this.dataLoader = false;
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       this.dataLoader = false;
    //     });
    // },
    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        columnDefs: [
          {
            targets: 0,
            className: "min-width-column",
          },
        ],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
    handleDownloadTable() {
      let url = "/api/v2/amazon/report_download";
      const payload = {
        headers: this.sleepwellTableHeader,
        name: "Campaign_Summary",
        data: this.sleepwellTableData,
        channel: this.selectedChannel.label,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.url;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleDownloadAsinTable() {
      let url = "/api/v2/amazon/report_download";

      const payload = {
        name: "Product_Summary",
        headers: this.asinTableHeader,
        data: this.asinTableData,
        channel: this.selectedChannel.label,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.url;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // transformToTreeSelect(data) {
    //   return Object.keys(data).map((category, idx) => {
    //     return {
    //       id: idx + category,
    //       label: category,
    //       parent: category,
    //       children: Object.keys(data[category]).map((type, idx) => {
    //         return {
    //           id: idx + category + type,
    //           parentCat: category,
    //           label: type,
    //           children: data[category][type].map((size, idx) => ({
    //             id: idx + category + type + size,
    //             cat: category,
    //             sub: type,
    //             label: size,
    //           })),
    //         };
    //       }),
    //     };
    //   });
    // },
    setInterval(selectedInterval) {
      this.selectedInterval = selectedInterval;
      this.getTableData();
      this.getAsinReportData();
    },
    handleTableColumn() {
      const dateColumn = this.sleepwellTableHeader.find(
        (item) => item.key === "Date"
      );

      if (!this.selectedTableColumn.some((col) => col.key === "Date")) {
        this.selectedTableColumn.unshift(dateColumn);
      }
      this.sleepwellTableHeader = this.selectedTableColumn;
    },

    // handleAsinTableColumn() {
    //   const dateColumn = this.asinTableHeader.find(
    //     (item) => item.key === "Date"
    //   );

    //   if (!this.selectedAsinTableColumn.some((col) => col.key === "Date")) {
    //     this.selectedAsinTableColumn.unshift(dateColumn);
    //   }
    //   this.asinTableHeader = this.selectedAsinTableColumn;
    // },
    handleCampaignType() {
      this.getTableData();
    },
    applyEnabledFilters() {
      this.getTableData();
    },
    // handleFilterModal(
    //   data,
    //   storeFilterValue,
    //   selectedMatricsValueKey,
    //   matricsInputValueKey
    // ) {
    //   if (data.length <= 0) {
    //     return false;
    //   }

    //   let existingValue = storeFilterValue.find(
    //     (item) =>
    //       item[0].field === data &&
    //       item[0].operation === this[selectedMatricsValueKey]
    //   );

    //   if (existingValue) {
    //     // this[selectedMatricsValueKey] = existingValue[0].operation;
    //     this[matricsInputValueKey] = existingValue[0].value;
    //   } else {
    //     this[matricsInputValueKey] = "";
    //   }
    // },
    // handleNumericFilterModal(data) {
    //   this.handleFilterModal(
    //     data,
    //     this.storeNumericFilterValue,
    //     "selectedNumericMatricsValue",
    //     "matricsInputValue"
    //   );
    // },
    // handleNumericMatricFilterModal(data) {
    //   let existingValue = this.storeNumericFilterValue.find(
    //     (item) =>
    //       item[0].field === this.selectedNumericCampaignValue &&
    //       item[0].operation === data
    //   );
    //   if (existingValue) {
    //     this.matricsInputValue = existingValue[0].value;
    //   } else {
    //     this.matricsInputValue = "";
    //   }
    // },
    // handleStringFilterModal(data) {
    //   this.handleFilterModal(
    //     data,
    //     this.storeStringFilterValue,
    //     "selectedStringMatricsValue",
    //     "StringMatricsInputValue"
    //   );
    // },
    // handleAsinStringFilterModal(data) {
    //   this.handleFilterModal(
    //     data,
    //     this.storeAsinFilterValue,
    //     "selectedAsinStringMatricsValue",
    //     "asinMatricsStringInputValue"
    //   );
    // },
    // handleStringMatricsFilterModal(data) {
    //   let existingValue = this.storeStringFilterValue.find(
    //     (item) =>
    //       item[0].field === this.selectedStringCampaignValue &&
    //       item[0].operation === data
    //   );
    //   if (existingValue) {
    //     this.StringMatricsInputValue = existingValue[0].value;
    //   } else {
    //     this.StringMatricsInputValue = "";
    //   }
    // },
    // handleAsinFilterModal(data) {
    //   this.handleFilterModal(
    //     data,
    //     this.storeAsinFilterValue,
    //     "selectedAsinNumericalMatricsValue",
    //     "asinMatricsNumericalInputValue"
    //   );
    // },
    // handleAsinMatricsFilterModal(data) {
    //   let existingValue = this.storeAsinFilterValue.find(
    //     (item) =>
    //       item[0].field === this.selectedAsinNumericalCampaignValue &&
    //       item[0].operation === data
    //   );
    //   if (existingValue) {
    //     this.asinMatricsNumericalInputValue = existingValue[0].value;
    //   } else {
    //     this.asinMatricsNumericalInputValue = "";
    //   }
    // },
    // handleAsinStringMatricsFilterModal(data) {
    //   let existingValue = this.storeAsinMetricsValue.find(
    //     (item) =>
    //       item[0].field === this.selectedAsinStringCampaignValue &&
    //       item[0].operation === data
    //   );
    //   if (existingValue) {
    //     this.asinMatricsStringInputValue = existingValue[0].value;
    //   } else {
    //     this.asinMatricsStringInputValue = "";
    //   }
    // },
    // handleIsFilter() {
    //   const existingValue = this.storeNumericFilterValue.find(
    //     (item) => item[0].field === this.selectedNumericCampaignValue
    //   );

    //   if (existingValue) {
    //     this.selectedNumericMatricsValue = existingValue[0].operation;
    //     this.matricsInputValue = existingValue[0].value;
    //   }
    //   this.matricsInputValue = "";
    //   this.StringMatricsInputValue = "";
    //   this.isFilter = true;
    // },
    // handleIsAsinFilter() {
    //   const existingValue = this.storeAsinFilterValue.find(
    //     (item) => item[0].field === this.selectedAsinNumericalCampaignValue
    //   );

    //   if (existingValue) {
    //     this.selectedAsinNumericalMatricsValue = existingValue[0].operation;
    //     this.asinMatricsNumericalInputValue = existingValue[0].value;
    //   }
    //   this.asinMatricsNumericalInputValue = "";
    //   this.asinMatricsStringInputValue = "";
    //   this.isAsinFilter = true;
    // },
    // clearFilter() {
    //   this.isFilter = false;
    //   this.matricsInputValue = "";
    //   this.StringMatricsInputValue = "";
    // },
    // clearAsinFilter() {
    //   this.isAsinFilter = false;
    // },
    // removeFilterValue(storeFilterValue, data) {
    //   const index = storeFilterValue
    //     .flat()
    //     .findIndex(
    //       (item) =>
    //         item.field === data.field &&
    //         item.operation === data.operation &&
    //         item.value === data.value
    //     );

    //   if (index !== -1) {
    //     storeFilterValue.splice(index, 1);
    //   }
    // },
    // RemoveBadgeValue(data) {
    //   this.removeFilterValue(this.storeNumericFilterValue, data);

    //   for (let i = 0; i < this.storeStringFilterValue.length; i++) {
    //     const itemArray = this.storeStringFilterValue[i];
    //     const matchIndex = itemArray.findIndex(
    //       (item) =>
    //         item.field === data.field &&
    //         item.operation === data.operation &&
    //         item.value === data.value
    //     );

    //     if (matchIndex !== -1) {
    //       this.storeStringFilterValue.splice(i, 1);
    //       break;
    //     }
    //   }
    //   this.removeFilterValue(this.storeAsinFilterValue, data);
    //   this.removeFilterValue(this.storeAsinMetricsValue, data);
    //   this.getTableData();
    //   this.getAsinReportData();
    // },
  //   RemoveAllBadgeValue() {
  //     this.storeNumericFilterValue = [];
  //     this.storeStringFilterValue = [];
  //     this.getTableData();
  //   },
  //   ResetAsinFilter() {
  //     this.storeAsinFilterValue = [];
  //     this.storeAsinMetricsValue = [];
  //     this.getAsinReportData();
  //   },
  //   handlePostFilters({
  //     selectedCampaignValue,
  //     selectedMatricsValue,
  //     matricsInputValue,
  //     storeFilterValue,
  //     getTableDataFunction,
  //   }) {
  //     if (!matricsInputValue) {
  //       return false;
  //     }
  //     let existingFilter = storeFilterValue.find(
  //       (item) =>
  //         item[0].field === selectedCampaignValue &&
  //         item[0].operation === selectedMatricsValue
  //     );

  //     if (existingFilter) {
  //       // existingFilter[0].operation = selectedMatricsValue;
  //       existingFilter[0].value = isNaN(matricsInputValue)
  //         ? matricsInputValue
  //         : parseFloat(matricsInputValue);
  //     } else {
  //       storeFilterValue.push([
  //         {
  //           operation: selectedMatricsValue,
  //           field: selectedCampaignValue,
  //           value: isNaN(matricsInputValue)
  //             ? matricsInputValue
  //             : parseFloat(matricsInputValue),
  //         },
  //       ]);
  //     }

  //     if (typeof getTableDataFunction === "function") {
  //       getTableDataFunction();
  //     }
  //   },
  //   postNumericalFilters() {
  //     this.handlePostFilters({
  //       selectedCampaignValue: this.selectedNumericCampaignValue,
  //       selectedMatricsValue: this.selectedNumericMatricsValue,
  //       matricsInputValue: this.matricsInputValue,
  //       storeFilterValue: this.storeNumericFilterValue,
  //       getTableDataFunction: this.getTableData,
  //     });
  //     this.isFilter = false;
  //   },

  //   handlePostStringFilters() {
  //     if (!this.StringMatricsInputValue) {
  //       return false;
  //     }
  //     this.storeStringFilterValue.push([
  //       {
  //         operation: this.selectedStringMatricsValue,
  //         field: this.selectedStringCampaignValue,
  //         value: this.StringMatricsInputValue,
  //       },
  //     ]);
  //     this.getTableData();
  //     this.isFilter = false;
  //   },

  //   postAsinFilters() {
  //     this.handlePostFilters({
  //       selectedCampaignValue: this.selectedAsinNumericalCampaignValue,
  //       selectedMatricsValue: this.selectedAsinNumericalMatricsValue,
  //       matricsInputValue: this.asinMatricsNumericalInputValue,
  //       storeFilterValue: this.storeAsinFilterValue,
  //       getTableDataFunction: this.getAsinReportData,
  //     });
  //     this.isAsinFilter = false;
  //   },

  //   postAsinMetricsFilters() {
  //     if (!this.asinMatricsStringInputValue) {
  //       return false;
  //     }
  //     this.storeAsinMetricsValue.push([
  //       {
  //         operation: this.selectedAsinStringMatricsValue,
  //         field: this.selectedAsinStringCampaignValue,
  //         value: this.asinMatricsStringInputValue,
  //       },
  //     ]);
  //     this.getAsinReportData();
  //     this.isAsinFilter = false;
  //   },

  //   handleTreeSelect(node) {
  //     if (this.selectedCategory) {
  //       if (node.parent) {
  //         this.selectedCategory[node.label] = {};
  //       } else if (node.parentCat) {
  //         if (this.selectedCategory[node.parentCat]) {
  //           this.selectedCategory[node.parentCat][node.label] = [];
  //         } else {
  //           this.selectedCategory[node.parentCat] = {};
  //           this.selectedCategory[node.parentCat][node.label] = [];
  //         }
  //       } else if (node.sub) {
  //         if (!this.selectedCategory[node.cat]) {
  //           this.selectedCategory[node.cat] = {};
  //         }

  //         if (!this.selectedCategory[node.cat][node.sub]) {
  //           this.selectedCategory[node.cat][node.sub] = [];
  //         }

  //         this.selectedCategory[node.cat][node.sub].push(node.label);
  //       }
  //       this.getAsinReportData();
  //     }
  //   },
  //   handleTreeDeSelect(node) {
  //     if (this.selectedCategory) {
  //       if (node.parent) {
  //         delete this.selectedCategory[node.label];
  //       } else if (node.parentCat) {
  //         if (this.selectedCategory[node.parentCat]) {
  //           delete this.selectedCategory[node.parentCat][node.label];

  //           if (
  //             Object.keys(this.selectedCategory[node.parentCat]).length === 0
  //           ) {
  //             delete this.selectedCategory[node.parentCat];
  //           }
  //         }
  //       } else if (node.sub) {
  //         if (
  //           this.selectedCategory[node.cat] &&
  //           this.selectedCategory[node.cat][node.sub]
  //         ) {
  //           const index = this.selectedCategory[node.cat][node.sub].indexOf(
  //             node.label
  //           );
  //           if (index > -1) {
  //             this.selectedCategory[node.cat][node.sub].splice(index, 1);
  //           }

  //           if (this.selectedCategory[node.cat][node.sub].length === 0) {
  //             delete this.selectedCategory[node.cat][node.sub];
  //           }

  //           if (Object.keys(this.selectedCategory[node.cat]).length === 0) {
  //             delete this.selectedCategory[node.cat];
  //           }
  //         }
  //       }

  //       this.getAsinReportData();
  //     }
  //   },
  //   handleClear(newValue) {
  //     if (!newValue || newValue.length === 0) {
  //       this.selectedCategory = {};
  //       this.getAsinReportData();
  //     }
  //   },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  position: absolute;
  content: "";
  height: 19px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #065559;
}

input:checked + .slider::before {
  transform: translateX(24px);
}
</style>
<style lang="scss" scoped>
.card {
  border-radius: 0.7rem;
  border: none;
  margin-bottom: 1rem;
  padding: 1rem;
  background: #fff;
}
.customMultiselectCommon .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselectCommon span.multiselect__single {
  display: flex;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customMultiselectCommon .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  font-family: "poppins";
  overflow-y: auto !important;
}

.customMultiselectCommon .multiselect__tags .multiselect__single {
  font-size: 14px !important;
}

.customMultiselectCommon .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselectCommon
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselectCommon .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
  font-size: 14px !important;
}

/* width */
.customMultiselectCommon ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselectCommon ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselectCommon ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselectCommon ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

.customMultiselectCommon .multiselect__input:focus {
  border: none !important;
  color: #000 !important;
  box-shadow: none;
}
</style>
<style>
#customDropdown select:focus {
  border-color: #b3b2b9 !important;
  box-shadow: none !important;
}

#customDropdown select {
  border-color: #b3b2b9 !important;
}

input[type="text"]:focus {
  box-shadow: none !important;
}
.vue-treeselect__control {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  border: 1px solid #b3b2b9 !important;
  padding: 0px !important;
}

.vue-treeselect__multi-value {
  min-width: 200px;
}

.vue-treeselect--has-value .vue-treeselect__multi-value {
  margin-bottom: 0px !important;
}

@media (max-width: 1280px) {
  .vue-treeselect__control {
    height: 34px !important;
    padding: 0px !important;
    font-size: 13px !important;
  }

  .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value
    .vue-treeselect__input-container {
    padding: 0px !important;
  }

  #customDropdown select {
    height: 34px;
    padding-top: 1px;
    font-size: 13px;
  }

  #customDropdown input {
    height: 30px;
  }
}

table.dataTable .sorting {
  background-color: #0655591a !important;
  color: black !important;
  font-weight: 500 !important;
}
.min-width-column {
  min-width: 100px !important;
}
#asinDataTable tfoot,
#campaignDataTable tfoot {
  background-color: #0655591a !important;
  color: black !important;
}
</style>
<style scoped>
.toggle-switch-container {
  position: relative;
  width: 50px;
  height: 25px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  position: absolute;
  content: "";
  height: 19px;
  width: 19px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #065559;
}

input:checked + .slider::before {
  transform: translateX(24px);
}
</style>
